import ApplicationRoleMembershipSection from "components/settings/permissions/application-roles/appication-role-membership-section/application-role-membership-section";


export default function ApplicationRoleMembership() {

    return (
        <ApplicationRoleMembershipSection />
    );
}